export default "/images/Energy_Storage.webp?29c0522d7b1138129a5c33e930210a66";